import { DataTypes } from 'business/definitions';
import { DateFilterValues } from '../PrintableFilterValues/DateFilterValues';
import { FilterValuesProps } from '../PrintableFilterValues/FilterValueWrapper';
import RegularFilterValues from '../PrintableFilterValues/RegularFilterValues';
import YearFilterValues from '../PrintableFilterValues/YearFilterValues';

type GetPrintableFilterValuesManagerT = (
    props: FilterValuesProps,
) => React.ReactElement<FilterValuesProps>;

/** Get the component to display the filter values
 * @param {SentenceFilterT} filter - the filter to display
 * @returns the component to display the filter values
 */
export const getPrintableFilterValuesManager = (
    filter: SentenceFilterT,
): GetPrintableFilterValuesManagerT => {
    const isDefaultTimeFilter = filter.field === 'default_time';
    const isYearFilter = filter.type === DataTypes.year;

    if (isDefaultTimeFilter) {
        return DateFilterValues;
    }
    if (isYearFilter) {
        return YearFilterValues;
    }
    return RegularFilterValues;
};
